'use es6';

import { createIndexedDBSuperstore } from 'superstore';
import { ensureFn, ensurePromise } from './helpers';

function adaptAsyncStore(store) {
  let asyncStore;
  const openStore = ensureFn(store.open).bind(store);
  return (method, ...args) => {
    if (!asyncStore) {
      asyncStore = openStore();
    }

    return new Promise(resolve => {
      const storeTimeout = setTimeout(() => resolve(ensurePromise()), 1000);
      ensurePromise(asyncStore).then(resolvedStore => {
        clearTimeout(storeTimeout);
        const storeOperation = ensureFn(resolvedStore[method]).bind(resolvedStore);
        resolve(ensurePromise(storeOperation(...args)));
      }).catch(() => {
        clearTimeout(storeTimeout);
        resolve(ensurePromise());
      });
    });
  };
}

export function getDefaultStore() {
  return new createIndexedDBSuperstore({
    namespace: 'laboratory'
  });
}
export function getAsyncStore(store) {
  return adaptAsyncStore(store || getDefaultStore());
}